module.exports = __webpack_public_path__ + "img/mc-full.d5bca250.jpg";